<template>
  <div class="call-form">
    <h1 id="form-title" class="text-center mb-5">
      {{ saveStrategy.getFormTitle() }}
    </h1>
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form id="call-form-element" @submit.prevent="handleSubmit(onSubmit)">
        <transition name="fade">
          <div v-if="duration" class="duration-widget">{{ duration }}</div>
        </transition>
        <b-container class="form-content" fluid="md">
          <date-with-now
            title="Hívás kezdete:"
            id="report-start-time"
            property="reportTime"
            ref="reportTime"
            component-id="start-report"
            :form-type="form.type"
          ></date-with-now>
          <b-row class="mt-3" align-h="start">
            <b-col cols="2">
              <b-form-radio-group
                v-model="form.type"
                :options="formtypeOptions"
                buttons
                button-variant="outline-info"
                size="lg"
              ></b-form-radio-group>
            </b-col>
          </b-row>
          <div class="inadequate-part" v-if="form.type == 'inadequate'">
            <b-row class="mt-3" align-h="center">
              <b-col class="mt-4">
                <b-form-group>
                  <radio-buttons
                    name="Hívás típusa"
                    :items="inadequateTypeOptions"
                    property="inadequateCallType"
                    ref="inadequateCallType"
                  >
                  </radio-buttons>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="adequate-part" v-if="form.type == 'adequate'">
            <b-row class="mt-3">
              <b-col align-self="end" class="text-right mt-2">
                <b-form-checkbox-group
                  :options="crisisOptions"
                  buttons
                  button-variant="outline-danger"
                  name="crisis-buttons"
                  id="crisis-buttons"
                  v-model="crisisSelector"
                ></b-form-checkbox-group>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <b-form-group
                  description="Ide 90 betűhely fér. Ez megy a leszwinbe."
                >
                  <label for="first-sentences">Első fontos mondatok</label>
                  <b-form-textarea
                    id="first-sentences"
                    rows="4"
                    v-model="form.firstSentences"
                    maxLength="90"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <label for="caller-description"
                  >Hívó elnevezése, jellemző leírása</label
                >
                <b-form-textarea
                  id="caller-description"
                  rows="4"
                  v-model="form.callerDescription"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <alternate-numeric-field
                label="Hívó kora*"
                property="age"
                ref="age"
              ></alternate-numeric-field>
              <radio-buttons
                name="Hívó neme*"
                :items="sexOptions"
                ref="sex"
                property="sex"
              ></radio-buttons>
              <radio-buttons
                name="Hívás gyakorisága*"
                :items="frequencyOptions"
                property="callFrequency"
                ref="callFrequency"
              ></radio-buttons>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <label for="short-content"
                  >Beszélgetés rövid tartalma (a hívó kulcsmondataival)</label
                >
                <b-form-textarea
                  id="short-content"
                  rows="4"
                  v-model="form.shortContent"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col>
                <label for="helper-descriptions"
                  >Ügyelő megjegyzései, rövid válaszai</label
                >
                <b-form-textarea
                  id="helper-descriptions"
                  rows="4"
                  v-model="form.helperDescriptions"
                ></b-form-textarea>
              </b-col>
            </b-row>
            <hr />
            <b-form-group ref="problems">
              <problems id="problems"></problems>
            </b-form-group>
            <hr />
            <b-row class="mt-3">
              <b-col>
                <check-boxes
                  :items="expectationOptions"
                  name="Hívó elvárásai*"
                  :otherField="true"
                  elementId="expectations"
                  property="expectations"
                  ref="expectations"
                >
                </check-boxes>
                <check-boxes
                  :items="relationLevelOptions"
                  name="A segítő kapcsolat szintjei*"
                  :otherField="true"
                  ref="relationLevel"
                  elementId="relation-level"
                  property="relationLevel"
                >
                </check-boxes>
              </b-col>
              <b-col>
                <check-boxes
                  :items="actionsOptions"
                  name="Irányítás, intézkedés"
                  :otherField="true"
                  property="actions"
                  elementId="actions"
                >
                </check-boxes>
              </b-col>
              <b-col>
                <check-boxes
                  :items="therapiesOptions"
                  name="Terápiás alapelemek*"
                  :otherField="true"
                  elementId="therapies"
                  property="therapies"
                  ref="therapies"
                >
                </check-boxes>
              </b-col>
            </b-row>
            <hr />
            <b-row class="mt-3">
              <radio-buttons
                name="Hívóval való összhang"
                :items="collaborationOptions"
                property="collaboration"
              ></radio-buttons>
              <radio-buttons
                name="Beszélgetés hatékonysága"
                :items="efficiencyOptions"
                property="efficiency"
              ></radio-buttons>
              <radio-buttons
                name="Hívó elégedett*"
                :items="yesNoOptions"
                ref="callerSatisfied"
                property="callerSatisfied"
              ></radio-buttons>
              <radio-buttons
                name="Segítő elégedett*"
                :items="yesNoOptions"
                ref="helperSatisfied"
                property="helperSatisfied"
              ></radio-buttons>
            </b-row>
            <b-row class="mt-3">
              <radio-buttons
                name="Családi állapot"
                :items="maritalOptions"
                property="maritalState"
              ></radio-buttons>
              <radio-buttons
                name="Foglalkozás"
                :items="professionOptions"
                property="profession"
              ></radio-buttons>
              <b-col sm></b-col>
              <b-col sm-cols="6">
                <b-form-group label="Gyerekeinek száma">
                  <b-form-input
                    type="number"
                    v-model="form.childrenNumber"
                    id="children-number"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Hányadik gyerek">
                  <b-form-input
                    type="number"
                    v-model="form.orderInSiblings"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Testvéreinek a száma">
                  <b-form-input
                    type="number"
                    v-model="form.siblingsNumber"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Válásainak a száma">
                  <b-form-input
                    type="number"
                    v-model="form.divorceCount"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <hr />
          <h1 class="text-center mb-5">Rögzítés lezárása</h1>
          <date-with-now
            title="Hívás vége:"
            id="report-end-time"
            property="endReportTime"
            ref="endReportTime"
            component-id="end-report"
            :form-type="form.type"
          ></date-with-now>
          <b-row class="mt-3" align-h="center">
            <b-col sm="*"
              ><b-button id="submit-button" type="submit" variant="info">{{
                saveStrategy.getSubmitButtonText()
              }}</b-button></b-col
            >
          </b-row>
        </b-container>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import FormService from '@/services/FormService'
import ValidationService from '@/services/ValidationService'
import AlternateNumericField from '@/components/AlternateNumericField'
import RadioButtons from '@/components/RadioButtons'
import CheckBoxes from '@/components/CheckBoxes'
import Problems from '@/components/Problems'
import Expectations from '@/texts/expectations.json'
import Actions from '@/texts/actions.json'
import RelationLevels from '@/texts/relationlevels.json'
import Therapies from '@/texts/therapies.json'
import { messages } from '@/texts/messages'
import { AuthenticationError, ServerSideError } from '@/errors/errors'
import jwtDecode from 'jwt-decode'
import DateWithNow from '@/components/DateWithNow'
import { ValidationObserver } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import CreateStrategy from '@/saveStrategies/createStrategy'
import UpdateStrategy from '@/saveStrategies/updateStrategy'
import FormId from '@/formId'
import debounce from 'lodash/debounce'
import { DateTime, Duration } from 'luxon'

export default {
  name: 'call-form',
  components: {
    RadioButtons,
    CheckBoxes,
    Problems,
    DateWithNow,
    ValidationObserver,
    AlternateNumericField,
  },
  data() {
    return {
      ageOptions: [
        '0-20',
        '21-30',
        '31-40',
        '41-50',
        '51-60',
        '61-70',
        '71-80',
        '80+',
        'nem ismert',
      ],
      sexOptions: ['férfi', 'nő', 'nem ismert'],
      frequencyOptions: ['első', 'visszahívó', 'krónikus', 'nem ismert'],
      collaborationOptions: [
        'azonos',
        'jó',
        'változó',
        'gyenge',
        'hiányos',
        'nem ismert',
      ],
      efficiencyOptions: [
        'sorsdöntő',
        'sokat segített',
        'kicsit segített',
        'eredménytelen',
        'ártott',
        'nem ismert',
      ],
      yesNoOptions: ['igen', 'nem', 'nem ismert'],
      maritalOptions: [
        'nőtlen/hajadon',
        'házas/együttélő',
        'elvált',
        'özvegy',
        'nem ismert',
      ],
      formtypeOptions: [
        { text: 'Adekvát', value: 'adequate' },
        { text: 'Inadekvát', value: 'inadequate' },
      ],
      crisisOptions: [
        { text: 'Krízis', value: 'crisis' },
        { text: 'Szuicid', value: 'suicide' },
      ],
      professionOptions: [
        'önálló, vállalkozó',
        'foglalkoztatott',
        'munkanélküli',
        'nyugdíj, gyes',
        'eltartott, tanuló',
        'nem ismert',
      ],
      requiredFieldsForAdequate: [
        'callFrequency',
        'expectations',
        'sex',
        'age',
        'therapies',
        'callerSatisfied',
        'helperSatisfied',
        'relationLevel',
        'problems',
      ],
      requiredFieldsForInadequate: ['inadequateCallType'],
      expectationOptions: Expectations,
      actionsOptions: Actions,
      therapiesOptions: Therapies,
      relationLevelOptions: RelationLevels,
      inadequateTypeOptions: [
        'téves',
        'üres, néma',
        'hecc – esély sincs kölcsönös kommunikációra',
        'zaklatás',
        'egyéb',
      ],
      saveStrategy: {},
      fromURL: '',
    }
  },
  watch: {
    form: {
      handler: function () {
        this.removeMarkFromCorrectedRequiredFields()
        this.setEndReportTimeToTheStartIfNotSet()
      },
      deep: true,
    },
  },
  computed: {
    form: {
      get() {
        return this.$store.state.form
      },
      set(value) {
        return value
      },
    },
    duration() {
      if (!this.form.reportTime || !this.form.endReportTime) return null

      const start = DateTime.fromFormat(
        this.form.reportTime,
        'yyyy-MM-dd HH:mm'
      ).toMillis()
      const end = DateTime.fromFormat(
        this.form.endReportTime,
        'yyyy-MM-dd HH:mm'
      ).toMillis()
      const duration = Duration.fromMillis(end - start)
      if (duration.values.milliseconds == 0) return '1 perc'

      return duration.toFormat('m') + ' perc'
    },
    crisisSelector: {
      get() {
        let crisises = []
        this.$store.state.form.suicide ? crisises.push('suicide') : true
        this.$store.state.form.crisis ? crisises.push('crisis') : true
        this.$store.state.form.covid ? crisises.push('covid') : true
        return crisises
      },
      set(crisises) {
        this.$store.state.form.suicide = crisises.includes('suicide')
        this.$store.state.form.covid = crisises.includes('covid')
        this.$store.state.form.crisis = crisises.includes('crisis')
      },
    },
    formId: {
      get() {
        return this.$store.state.formId
      },
      set(formId) {
        this.$store.commit('setFormId', formId)
      },
    },
  },
  created() {
    this.createSaveStrategy()
  },
  async mounted() {
    try {
      await this.saveStrategy.init(
        this.$store,
        this.uglyFormIdGetterFromQuery(),
        this.$session.get('token')
      )
    } catch (error) {
      this.showModal(error.message, () => this.$router.go())
    }
  },
  methods: {
    createSaveStrategy() {
      this.saveStrategy = this.newFormCreated()
        ? new CreateStrategy()
        : new UpdateStrategy()
    },
    newFormCreated() {
      return (
        (this.$route === undefined || this.$route.query.id === undefined) &&
        !this.$store.getters.formAlreadyLoaded
      )
    },
    uglyFormIdGetterFromQuery() {
      return this.$route
        ? this.$route.query
          ? this.$route.query.id || undefined
          : undefined
        : undefined
    },
    onSubmit: debounce(
      async function () {
        this.setReportTimesToNowIfItsNecessary()
        const validator = new ValidationService(this.form)

        const problemsFieldState = validator.checkFieldsExistence(['problems'])
        if (
          this.form.type !== 'inadequate' &&
          problemsFieldState?.badFields?.length > 0
        ) {
          this.modalWithTimeOutAndClose(messages.problems_field_is_required)
          this.markBadFieldsAndScrollToTheFirstOne(problemsFieldState.badFields)
          return
        }

        const validFieldsState = validator.checkFieldsExistence(
          this.getRequiredFields()
        )

        if (validFieldsState?.badFields?.length > 0) {
          this.markBadFieldsAndScrollToTheFirstOne(validFieldsState.badFields)
        }

        if (!validator.isEndReportLaterThanStart()) {
          this.modalWithTimeOutAndClose(messages.end_report_time_is_earlier)
          return
        }

        if (validator.reportTimesInFuture()) {
          this.modalWithTimeOutAndClose(messages.time_is_in_future)
          return
        }

        let modalMessage
        const service = new FormService()
        try {
          this.form.user = this.getUsernameFromToken()
          const formId = await this.saveStrategy.save(
            this.$session.get('token'),
            this.form,
            this.formId
          )

          this.saveStrategy = new UpdateStrategy()
          await this.saveStrategy.init(
            this.$store,
            formId,
            this.$session.get('token')
          )

          if (validFieldsState?.badFields?.length > 0) {
            this.showSavedWithMissingFieldsModal(
              validFieldsState.badFields,
              () => {
                this.hideModal()
                location.hash = ''
                this.$router.go()
              },
              () => this.hideModal(),
              this.saveStrategy.submitCallback(this)
            )
          } else {
            this.showModal(
              messages.ok + ' ' + formId,
              this.saveStrategy.submitCallback(this)
            )
          }
        } catch (e) {
          this.showModal(e.message, this.saveStrategy.submitCallback(this))
        }
      },
      process.env.VUE_APP_DEBOUNCE_RATE,
      { leading: true }
    ),
    getUsernameFromToken() {
      return jwtDecode(this.$session.get('token')).username
    },
    setEndReportTimeToTheStartIfNotSet() {
      if (this.form.endReportTime != '') return
      this.form.endReportTime = this.form.reportTime
    },
    setReportTimesToNowIfItsNecessary() {
      if (this.form.type !== 'inadequate') return
      this.form.reportTime =
        this.form.reportTime == '' ? this.getNow() : this.form.reportTime
      this.form.endReportTime =
        this.form.endReportTime == '' ? this.getNow() : this.form.endReportTime
    },
    modalWithTimeOutAndClose(message) {
      const hide = () => this.$modal.hide('dialog')
      this.showModal(message, hide)
      setTimeout(hide, 3000)
    },
    handleMissingFields(badFields) {
      this.markBadFieldsAndScrollToTheFirstOne(badFields)
      this.modalWithTimeOutAndClose(messages.required_fields_error)
    },
    markBadFieldsAndScrollToTheFirstOne(fieldStates) {
      fieldStates.forEach((invalidField) =>
        this.$refs[invalidField].$el.classList.add('required-missing')
      )

      const firstBad = this.$refs[fieldStates[0]].$el
      window.scrollBy({
        top: firstBad.getBoundingClientRect().top - 70,
        behavior: 'smooth',
      })
    },
    getNow() {
      return DateTime.local().toFormat('yyyy-MM-dd HH:mm')
    },
    showModal(message, handler) {
      this.$modal.show('dialog', {
        text:
          '<div style="text-align: center"><strong>' +
          message +
          '</strong></div>',
        buttons: [{ title: 'Oké', handler }],
        transition: 'fade',
      })
    },
    showSavedWithMissingFieldsModal(
      missingFields,
      newCallHandler,
      continueHandler,
      goToFormsHandler
    ) {
      const missingFieldsNode = missingFields.map(
        (field) => `<li key=${field}>${messages[field]}</li>`
      )
      this.$modal.show('dialog', {
        text: `<div>
            <h2>Mentés sikeres, de hiányos!</h2>
            <div>Az alábbi kötelező mezők nem kerültek kitöltésre:</div>
            <ul>
                ${missingFieldsNode.join('')}
            </ul>

              Az adatok pótlására 7 napig van lehetőség!

              Ellenkező esetben az adatlapot nem tudjuk feltölteni a LeszWinbe.</div>
            </div>`,
        buttons: [
          { title: 'Új hívás rögzítése', handler: newCallHandler },
          { title: 'Szerkesztés folytatása', handler: continueHandler },
          { title: 'Ugrás az űrlapjaimhoz', handler: goToFormsHandler },
        ],
        transition: 'fade',
      })
    },
    hideModal() {
      this.$modal.hide('dialog')
    },
    getRequiredFields() {
      let requiredFields
      if (this.form.type == 'inadequate')
        requiredFields = this.requiredFieldsForInadequate
      else requiredFields = this.requiredFieldsForAdequate
      return requiredFields
    },
    removeMarkFromCorrectedRequiredFields() {
      const validator = new ValidationService(this.form)
      const validFieldsState = validator.checkFieldsExistence(
        this.getRequiredFields()
      )

      const requiredFields = this.getRequiredFields()
      requiredFields.forEach((requiredField) => {
        if (
          validFieldsState.badFields.includes(requiredField) ||
          this.$refs[requiredField] === undefined
        ) {
          return
        }
        this.$refs[requiredField].$el.classList.add('removed-required-missing')
        this.$refs[requiredField].$el.classList.remove('required-missing')
        setTimeout(() => {
          this.$refs[requiredField]
            ? this.$refs[requiredField].$el.classList.remove(
                'removed-required-missing'
              )
            : null
        }, 1000)
      })
    },
  },
}
</script>

<style scoped>
label,
legend {
  font-weight: bold;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

hr {
  margin: 3em 0 2em;
  border: 1px dashed rgb(160, 160, 160);
}

.call-form {
  padding-bottom: 3em;
}

.required-missing {
  background-color: rgb(255, 205, 201);
  margin: 0.5em;
  padding: 0.5em;
  border: 1px solid red;
}

.removed-required-missing {
  background-color: white;
  border: none;
  transition: background-color 0.7s;
}

.duration-widget {
  position: fixed;
  background: white;
  right: 0;
  top: 30%;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  font-weight: bold;
  border: 2px solid rgb(23, 162, 184);
  border-right: none;
  box-shadow: 4px 4px #dfdfdf;
  z-index: 100;
}
</style>
